import { Box, Paper, Typography } from "@mui/material";

import "./QBR.scss";
import Loader from "../Loader";
import TerritoryOverviewCard from "./TerritoryOverviewCard";
import { useQBRController } from "./useQBRController";

const ACCENT_ORANGE = "#E87722";

/** Calendar quarter the report covers, e.g. "Q3 2026". */
function currentQuarterLabel(now = new Date()) {
  return `Q${Math.floor(now.getMonth() / 3) + 1} ${now.getFullYear()}`;
}

function HeaderChip({ children }) {
  return (
    <Typography
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        border: "1px solid #D0D5DD",
        borderRadius: "999px",
        px: 1.5,
        py: 0.5,
        fontSize: 13,
        fontWeight: 600,
        color: "#202020",
        lineHeight: 1.2,
        bgcolor: "#fff",
      }}
    >
      {children}
    </Typography>
  );
}

function QBR({ isActive = true }) {
  const {
    overview,
    onOverviewChange,
    isLoading,
    hasData,
    productGroupLabel,
  } = useQBRController({ isActive });

  return (
    <>
      {isLoading && !hasData && <Loader />}
      <Box
        sx={{
          position: "sticky",
          top: "142px",
          backgroundColor: "#f9fdff",
          zIndex: 9,
          width: "100%",
          maxWidth: "1360px",
          m: "0 auto",
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 0.75,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.25,
              flexWrap: "wrap",
            }}
          >
            <Typography
              sx={{
                fontSize: 22,
                fontWeight: 600,
                color: "#202020",
                lineHeight: 1.1,
              }}
            >
              My Dashboard: QBR
            </Typography>
            <HeaderChip>{currentQuarterLabel()}</HeaderChip>
          </Box>
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 600,
              color: ACCENT_ORANGE,
              lineHeight: 1.2,
            }}
          >
            Data autopopulated from RepAssist
          </Typography>
        </Box>
      </Box>

      <Paper elevation={3} className="drawer-paper-qbr">
        <Box
          sx={{
            p: 2,
            width: "100%",
            maxWidth: "1360px",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <TerritoryOverviewCard
            overview={overview}
            onOverviewChange={onOverviewChange}
          />

          {/* Placeholder: Sections 2–4 (HCP Targets, Progressing Targets, New Targets) go here later. */}
        </Box>
      </Paper>
    </>
  );
}

export default QBR;
